import { replace } from 'lodash'
import * as ModalActions from '../actions/Modals'
import { gaEvent } from '../common/services/analytics'
import { history } from '../store'

export function openModal({ data, modalId }) {
  return (dispatch) => {
    dispatch(ModalActions.openModal({ data, modalId }))

    let label = history.location.pathname
    label = replace(label, /[a-f\d]{24}/i, ':id')

    gaEvent({
      category: 'Forms',
      action: `Open ${modalId} modal`,
      label: `From: ${label}`
    })
  }
}
